import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { RECIPIENT_LABELS, EVENT_TYPE_OPTIONS, TEMPLATE_KIND_OPTIONS, TEMPLATE_KIND_ICONS } from './notifications.constants'

export function formatUserLabel(user) {
  const fio = [user.surname, user.name, user.patronymic].filter(Boolean).join(' ')
  return `${fio || `Пользователь #${user.id}`} - ${user.id}`
}

export function normalizeUser(user) {
  return {
    id: user.id,
    name: user.name,
    surname: user.surname,
    patronymic: user.patronymic,
    email: user.email,
    displayName: formatUserLabel(user),
  }
}

export function showNotificationError(vm, e) {
  const message = e?.response?.data?.message || e?.message || 'Ошибка'
  vm.$toast({
    component: ToastificationContent,
    props: { title: message, icon: 'AlertTriangleIcon', variant: 'danger' },
  })
}

export function formatNotificationDate(value) {
  return value ? moment(value).format('DD.MM.YYYY HH:mm') : '—'
}

export function formatCreator(creator) {
  if (!creator) return 'Система'
  return [creator.surname, creator.name].filter(Boolean).join(' ') || creator.email || `#${creator.id}`
}

export function recipientTypeLabel(type) {
  return RECIPIENT_LABELS[type] || type
}

export function templateKindLabel(kind) {
  if (!kind) return 'Универсальное'
  const opt = TEMPLATE_KIND_OPTIONS.find(o => o.value === kind)
  return opt?.text || kind
}

export function templateKindIcon(kind) {
  if (!kind) return 'BellIcon'
  return TEMPLATE_KIND_ICONS[kind] || 'BellIcon'
}

export function eventTypeLabel(type) {
  if (!type) return '—'
  const opt = EVENT_TYPE_OPTIONS.find(o => o.value === type)
  return opt?.text || type
}

export function statusLabel(status) {
  const map = { sent: 'Отправлено', partial: 'Частично', failed: 'Ошибка' }
  return map[status] || status
}

export function statusVariant(status) {
  const map = { sent: 'light-success', partial: 'light-warning', failed: 'light-danger' }
  return map[status] || 'light-secondary'
}
